import { getRightList } from '@/infrastructure/api-functions';
import { ListBaseService } from '@eureka/solution-card';
import { SOLUTION_TYPE, type ISolutionListResponse, type IOrgInfo } from '@eureka/solution-card/src/types';

// 提取数据转换逻辑为独立函数，减少耦合
export function normalizeOrgInfo(orgs?: IOrgInfo[]) {
    return orgs?.map(org => ({
        display_name: org.normalized_display_name,
        id: org.normalized_id,
        logo: org.normalized_logo,
    }));
}

export class ProjectDrawerListService extends ListBaseService {
    protected fetchData(
        data: {
            page: number, limit: number, data?: Record<string, unknown>
        }
    ): Promise<ISolutionListResponse> {
        return getRightList(data).then(res => {
            res.records = res.records.map(item => ({
                ...item,
                ORG_INFO: item.SOLUTION_TYPE === SOLUTION_TYPE.PAPER ? normalizeOrgInfo(item.ORG_INFO) : item.ORG_INFO,
            }));
            return res
        })
    }
}
